import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useState } from "react";
import { functions } from "@poseidon/firebase/firebase";

export const useQuote = () => {
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "getQuote"
  );
  const [complete, setComplete] = useState(false);
  const [result, setResult] = useState(undefined);
  const getQuote = async (props) => {
    try {
      setResult(await executeCallable(props));
      setComplete(true);
    } catch (err) {
      setComplete(false);
    }
  };
  return {
    saving,
    error,
    success: !saving && !error && complete,
    quote: result,
    getQuote,
  };
};
